import { render, staticRenderFns } from "./ResponsibleDisclosureProgram.vue?vue&type=template&id=259855ed"
import script from "./ResponsibleDisclosureProgram.vue?vue&type=script&lang=js"
export * from "./ResponsibleDisclosureProgram.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleDisclosureProgram.vue?vue&type=style&index=0&id=259855ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports